module.exports = __webpack_public_path__ + "static/media/template_contact.bc75fe3d.csv";